module.exports = __webpack_public_path__ + "static/media/matitone.e54c53ac.gif";